// Chatbot.js
import React, { useContext } from 'react';
import { ChatbotStateContext } from '../../Context/ChatbotStateContext';
import Welcome from './Welcome';
import SignIn from './SignIn';
import Chat from './chat';

const Chatbot = () => {
  const { currentStep } = useContext(ChatbotStateContext);

  return (
    <>
      {currentStep === 'welcome' && <Welcome />}
      {currentStep === 'register' && <SignIn />}
      {currentStep === 'chat' && <Chat />}
    </>
  );
};

export default Chatbot;